module.exports = __webpack_public_path__ + "static/media/bin.855d067c.png";